<template>
<div class="exCl">
  <div class="bgbox">

    <div class="mbbox">
      <el-button size="small" @click="showaddmbss" type="primary">增加新模板</el-button>
      <el-select size="small" style="margin: 0 20px;" v-model="cfval" placeholder="请选择">
        <el-option
            placeholder="选择处方"
            v-for="item in cfopin"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button size="small" type="primary" @click="showupmb = true">修改已选择模板</el-button>
      <el-button size="small" type="danger" @click="delmbfn">删除本处方模板</el-button>
    </div>

    <ul class="bt-m">
      <li>处置方案</li>
      <li>名称</li>
      <li>数量</li>
      <li>单价</li>
      <li>库存</li>
      <li>用法</li>
      <li>开单</li>
      <li>状态</li>
      <li>备注</li>
      <li></li>
    </ul>

    <ul class="bt-m nrboxo" v-for="(item,idx) in gwcyp" :class="item.CHPStatus == 2 ? 'ykd' : ''">
      <li>
        <p v-if="idx == 0">药品</p>
<!--        <el-button v-if="idx == 0" size="mini" type="primary" @click="addsp('drug')">添加</el-button>-->
        <i class="el-icon-plus" style="font-size: 20px;cursor: pointer;" v-if="idx == 0" @click="addsp('drug')"></i>
      </li>
      <li>
        <el-select v-model="item.CHPProductId" filterable :disabled="item.CHPStatus == 2" size="mini" @change="xzcp($event, idx, 'drug')" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in yparr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="item.CHPAmount" :disabled="item.CHPStatus == 2" filterable @change="xgnum($event, item.ChooseProductId)" size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in ypsls"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>{{item.ProductRelation.ShopProduct.SPShopPrice}}</li>
      <li>{{item.ProductRelation.ShopProduct.SPAmount}}</li>
      <li><span class="gzkd"  v-if="item.CHPProductId" @click="openypxq(idx)">用药详情</span></li>
      <li><span class="gzkd"  v-if="item.CHPProductId" @click="sqdFn('5', item.CHPProductSortGroup, item.CHPStatus, item.ChooseProductId)">处方单</span></li>
      <li v-if="item.ChooseProductId">{{item.CHPStatus != 2 ? item.zt : '已开单'}}</li>
      <li v-if="!item.ChooseProductId"><span v-if="item.CHPProductId">未保存</span></li>
      <li><input class="yf" type="text" v-model="item.CHPRemark" :disabled="item.CHPStatus == 2" placeholder="请输入"></li>
      <li>
        <el-button v-if="item.CHPStatus != 2" size="mini" type="danger" @click="deles(item.ChooseProductId, idx, 'drug')">删除</el-button>
        <span v-if="item.CHPStatus == 2">已开单</span>
      </li>
    </ul>

    <ul class="bt-m nrboxo" v-for="(item, idx) in gwcjc" :class="item.CHPStatus == 2 ? 'ykd' : ''">
      <li>
        <p v-if="idx == 0">检查</p>
<!--        <el-button v-if="idx == 0" size="mini" type="primary" @click="addsp('exam')">添加</el-button>-->
        <i class="el-icon-plus" style="font-size: 20px;cursor: pointer;" v-if="idx == 0" @click="addsp('exam')"></i>
      </li>
      <li>
        <el-select v-model="item.CHPProductId" filterable :disabled="item.CHPStatus == 2" @change="xzcp($event, idx, 'exam')" size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in jcarr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="item.CHPAmount" filterable :disabled="item.CHPStatus == 2"  size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in ypsls"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>{{item.ProductRelation.ShopProduct.SPShopPrice}}</li>
      <li>{{item.ProductRelation.ShopProduct.SPAmount}}</li>
      <li></li>
      <li><span v-if="item.CHPProductId" class="gzkd" @click="sqdFn('3', item.CHPProductSortGroup, item.CHPStatus, item.ChooseProductId)">检查单</span></li>
      <li v-if="item.ChooseProductId">{{item.CHPStatus != 2 ? item.zt : '已开单'}}</li>
      <li v-if="!item.ChooseProductId"><span v-if="item.CHPProductId">未保存</span></li>
      <li><input class="yf"  v-model="item.CHPRemark" :disabled="item.CHPStatus == 2" type="text" placeholder="请输入"></li>
      <li>
        <el-button v-if="item.CHPStatus != 2" size="mini" type="danger" @click="deles(item.ChooseProductId, idx, 'exam')">删除</el-button>
        <span v-if="item.CHPStatus == 2">已开单</span>
      </li>
    </ul>

    <ul class="bt-m nrboxo" v-for="(item, idx) in gwchy" :class="item.CHPStatus == 2 ? 'ykd' : ''">
      <li>
        <p v-if="idx == 0">化验检验</p>
        <!--        <el-button v-if="idx == 0" size="mini" type="primary" @click="addsp('exam')">添加</el-button>-->
        <i class="el-icon-plus" style="font-size: 20px;cursor: pointer;" v-if="idx == 0" @click="addsp('labtest')"></i>
      </li>
      <li>
        <el-select v-model="item.CHPProductId" filterable :disabled="item.CHPStatus == 2" @change="xzcp($event, idx, 'labtest')" size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in hyarr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="item.CHPAmount" filterable :disabled="item.CHPStatus == 2"  size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in ypsls"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>{{item.ProductRelation.ShopProduct.SPShopPrice}}</li>
      <li>{{item.ProductRelation.ShopProduct.SPAmount}}</li>
      <li></li>
      <li><span class="gzkd" v-if="item.CHPProductId" @click="sqdFn('2', item.CHPProductSortGroup, item.CHPStatus, item.ChooseProductId)">化验单</span></li>
      <li v-if="item.ChooseProductId">{{item.CHPStatus != 2 ? item.zt : '已开单'}}</li>
      <li v-if="!item.ChooseProductId"><span v-if="item.CHPProductId">未保存</span></li>
      <li><input class="yf"  v-model="item.CHPRemark" :disabled="item.CHPStatus == 2" type="text" placeholder="请输入"></li>
      <li>
        <el-button v-if="item.CHPStatus != 2" size="mini" type="danger" @click="deles(item.ChooseProductId, idx, 'labtest')">删除</el-button>
        <span v-if="item.CHPStatus == 2">已开单</span>
      </li>
    </ul>

    <ul class="bt-m nrboxo" v-for="(item, idx) in gwcmz" :class="item.CHPStatus == 2 ? 'ykd' : ''">
      <li>
        <p v-if="idx == 0">门诊治疗</p>
<!--        <el-button v-if="idx == 0" size="mini" type="primary"  @click="addsp('treatment')">添加</el-button>-->
        <i class="el-icon-plus" style="font-size: 20px;cursor: pointer;" v-if="idx == 0" @click="addsp('treatment')"></i>
      </li>
      <li>
        <el-select v-model="item.CHPProductId" :disabled="item.CHPStatus == 2" filterable  @change="xzcp($event, idx, 'treatment')" size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in mzarr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="item.CHPAmount" :disabled="item.CHPStatus == 2" filterable  size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in ypsls"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>{{item.ProductRelation.ShopProduct.SPShopPrice}}</li>
      <li>{{item.ProductRelation.ShopProduct.SPAmount}}</li>
      <li></li>
      <li><span v-if="item.CHPProductId" class="gzkd" @click="sqdFn('4', item.CHPProductSortGroup, item.CHPStatus, item.ChooseProductId)">门诊单</span></li>
      <li v-if="item.ChooseProductId">{{item.CHPStatus != 2 ? item.zt : '已开单'}}</li>
      <li v-if="!item.ChooseProductId"><span v-if="item.CHPProductId">未保存</span></li>
      <li><input class="yf"  v-model="item.CHPRemark" :disabled="item.CHPStatus == 2" type="text" placeholder="请输入"></li>
      <li>
        <el-button v-if="item.CHPStatus != 2" size="mini" type="danger" @click="deles(item.ChooseProductId, idx, 'treatment')">删除</el-button>
        <span v-if="item.CHPStatus == 2">已开单</span>
      </li>
    </ul>

    <ul class="bt-m nrboxo" v-for="(item, idx) in gwcss" :class="item.CHPStatus == 2 ? 'ykd' : ''">
      <li>
        <p v-if="idx == 0">手术</p>
<!--        <el-button v-if="idx == 0" size="mini" type="primary"  @click="addsp('operation')">添加</el-button>-->
        <i class="el-icon-plus" style="font-size: 20px;cursor: pointer;" v-if="idx == 0" @click="addsp('operation')"></i>
      </li>
      <li>
        <el-select v-model="item.CHPProductId" filterable :disabled="item.CHPStatus == 2" @change="xzcp($event, idx, 'operation')" size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in ssarr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="item.CHPAmount" filterable :disabled="item.CHPStatus == 2"  size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in ypsls"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>{{item.ProductRelation.ShopProduct.SPShopPrice}}</li>
      <li>{{item.ProductRelation.ShopProduct.SPAmount}}</li>
      <li></li>
      <li><span v-if="item.CHPProductId" class="gzkd" @click="sqdFn('1', item.CHPProductSortGroup, item.CHPStatus, item.ChooseProductId)">手术单</span> </li>
      <li v-if="item.ChooseProductId">{{item.CHPStatus != 2 ? item.zt : '已开单'}}</li>
      <li v-if="!item.ChooseProductId"><span v-if="item.CHPProductId">未保存</span></li>
      <li><input class="yf"  v-model="item.CHPRemark" :disabled="item.CHPStatus == 2" type="text" placeholder="请输入"></li>
      <li>
        <el-button v-if="item.CHPStatus != 2" size="mini" type="danger" @click="deles(item.ChooseProductId, idx, 'operation')">删除</el-button>
        <span v-if="item.CHPStatus == 2">已开单</span>
      </li>
    </ul>

    <ul class="bt-m nrboxo" v-for="(item, idx) in gwczy">
      <li>
        <p v-if="idx == 0">住院治疗</p>
        <!--        <el-button v-if="idx == 0" size="mini" type="primary"  @click="addsp('operation')">添加</el-button>-->
        <i class="el-icon-plus" style="font-size: 20px;cursor: pointer;" v-if="idx == 0" ></i>
      </li>
      <li>
        <el-select v-model="item.CHPProductId" filterable :disabled="item.CHPStatus == 2" @change="xzcp($event, idx, 'operation')" size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in zyarr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="item.CHPAmount" filterable :disabled="item.CHPStatus == 2"  size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in ypsls"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li><input class="yf"  v-model="item.CHPRemark" :disabled="item.CHPStatus == 2" type="text" placeholder="请输入"></li>
      <li>
        <el-button v-if="item.CHPStatus != 2" size="mini" type="danger">删除</el-button>
        <span v-if="item.CHPStatus == 2">已开单</span>
      </li>
    </ul>

    <ul class="bt-m nrboxo" v-for="(item, idx) in gwcqt">
      <li>
        <p v-if="idx == 0">其他</p>
        <!--        <el-button v-if="idx == 0" size="mini" type="primary"  @click="addsp('operation')">添加</el-button>-->
        <i class="el-icon-plus" style="font-size: 20px;cursor: pointer;" v-if="idx == 0"></i>
      </li>
      <li>
        <el-select v-model="item.CHPProductId" filterable :disabled="item.CHPStatus == 2" @change="xzcp($event, idx, 'operation')" size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in qtarr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="item.CHPAmount" filterable :disabled="item.CHPStatus == 2"  size="mini" style="width: 100%;" placeholder="请选择">
          <el-option
              v-for="item in ypsls"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>{{item.ProductRelation.ShopProduct.SPShopPrice}}</li>
      <li></li>
      <li></li>
      <li></li>
      <li>{{item.zt}}</li>
      <li><input class="yf"  v-model="item.CHPRemark" :disabled="item.CHPStatus == 2" type="text" placeholder="请输入"></li>
      <li>
        <el-button v-if="item.CHPStatus != 2" size="mini" type="danger" @click="deles(item.ChooseProductId, idx, 'operation')">删除</el-button>
        <span v-if="item.CHPStatus == 2">已开单</span>
      </li>
    </ul>
  </div>




  <el-dialog
      title="用药详情"
      :visible.sync="yyxqshow"
      width="60%">
    <ul class="yyxq">
      <li>
        <p>用药周期</p>
        <el-select
            :disabled="dqypzt"
            size="small"
            class="srr"
            filterable
            allow-create
            v-model="ypitem.Drug_Days"
        >
          <el-option
              v-for="item in ypxzarr.yyts"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <p>用药方式</p>
        <el-select
            :disabled="dqypzt"
            size="small"
            class="srr"
            filterable
            allow-create
            v-model="ypitem.Drug_UseMethod"
        >
          <el-option
              v-for="item in ypxzarr.yyfs"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
    </ul>
    <ul class="yyxq">
      <li>
        <p>用药频次</p>
        <el-select
            :disabled="dqypzt"
            size="small"
            class="srr"
            filterable
            allow-create
            v-model="ypitem.Drug_CountPerDay"
        >
          <el-option
              v-for="item in ypxzarr.cishu"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <p>用药规律</p>
        <el-select
            :disabled="dqypzt"
            size="small"
            class="srr"
            filterable
            allow-create
            v-model="ypitem.Drug_TimeInDay"
        >
          <el-option
              v-for="item in ypxzarr.shijian"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
    </ul>
    <ul class="yyxq">
      <li>
        <p>眼别</p>
        <el-select
            :disabled="dqypzt"
            size="small"
            class="srr"
            filterable
            allow-create
            v-model="ypitem.LeftOrRight"
        >
          <el-option
              :disabled="dqypzt"
              v-for="item in ypxzarr.yyyanbie"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
      <li>
        <p>每次用量</p>
        <el-select
            :disabled="dqypzt"
            size="small"
            class="srr"
            filterable
            allow-create
            v-model="ypitem.Drug_CountPerTime"
        >
          <el-option
              v-for="item in ypxzarr.yyyl"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </li>
    </ul>


    <el-button type="primary" style="margin-top: 20px;" @click.stop="desqd" size="small">确定</el-button>
  </el-dialog>

  <el-dialog
      title=""
      :visible.sync="showif"
      :close-on-press-escape="false"
      :close-on-click-modal='false'
      :show-close='false'
      width="850px">
    <IFTC v-if="showif" :srccs="ifcs" :cpxx="dqcfxx"></IFTC>
    <el-button type="primary" @click="showif = false">关闭</el-button>
  </el-dialog>

  <el-dialog
      title=""
      :visible.sync="showaddmb"
      :close-on-press-escape="false"
      :close-on-click-modal='false'
      width="500px">
    <p style="padding-bottom: 20px;">症状：{{odds || osds}}</p>
    <div style="display: flex;align-items: center">
      <p>模板名称：</p>
      <el-input style="width: 360px;" v-model="mbName" placeholder="请输入模板名称"></el-input>
    </div>
    <div style="padding: 15px 0; display: flex;align-items: center">
      <p>模板说明：</p>
      <el-input style="width: 360px;" v-model="mbsm" placeholder="请输入模板说明"></el-input>
    </div>
    <el-button type="primary" @click="addmb">保存成新模板</el-button>
  </el-dialog>

  <el-dialog
      title=""
      :visible.sync="showupmb"
      :close-on-press-escape="false"
      :close-on-click-modal='false'
      width="500px">
    <p style="padding-bottom: 20px;">症状：{{odds || osds}}</p>
    <div style="display: flex;align-items: center">
      <p>模板名称：</p>
      <el-input style="width: 360px;" v-model="dqcfobj.PTName" placeholder="请输入模板名称"></el-input>
    </div>
    <div style="padding: 15px 0;display: flex;align-items: center">
      <p>模板说明：</p>
      <el-input style="width: 360px;" v-model="dqcfobj.PTDescription" placeholder="请输入模板说明"></el-input>
    </div>
    <el-button type="primary" @click="upmb">保存模板</el-button>
  </el-dialog>
</div>
</template>

<script>
import {getGWC, getCp, numbh, getcflist, addnmb, cfxx, upmbfn, delemb} from './api'
import {ypxzarr, ypsl, getcsz, mbxx} from './xzdata'
import pf from "../../publicFn/baseFn";
export default {
  name: "exCl",
  data() {
    return {
      options: [],
      value1: '',
      yyxqshow: false,
      showif: false,
      ifcs: '',
      yparr : [],
      jcarr : [],
      mzarr: [],
      ssarr: [],
      hyarr: [],
      zyarr: [],
      qtarr: [],
      ypwzarr: [],
      jcwzarr: [],
      mzwzarr: [],
      sswzarr: [],
      hywzarr: [],
      zywzarr: [],
      qtwzarr: [],
      gwcyp: [getcsz('drug')],
      gwcmz: [getcsz('treatment')],
      gwcss: [getcsz('operation')],
      gwcjc: [getcsz('exam')],
      gwchy: [getcsz('labtest')],
      gwczy: [getcsz('zy')],
      gwcqt: [getcsz('qt')],
      ypitem: {
        Drug_Days: '',
        Drug_UseMethod: '',
        Drug_CountPerDay: '',
        Drug_TimeInDay: '',
        LeftOrRight: '',
        Drug_CountPerTime: '',
      },
      ypxqIdx: -1,
      ypxzarr,
      ypsls: ypsl(),
      cfval: '',
      allcf: [],
      cfopin: [],
      mbName: '',
      mbsm: '',
      showaddmb: false,
      dqcfobj: {},
      showupmb: false,
      dqypzt: false,
      dqcfxx: {}
    }
  },
  props: {
    odds: {
      default: ''
    },
    osds: {
      default: ''
    }
  },
  watch:{
    cfval: function (n) {
      if (n) {
        let log  = this.$loading({text: '加载中...'})
        cfxx(n)
            .then(res => {
              log.close()
              if (res.Result) {
                this.dqcfobj = JSON.parse(JSON.stringify(res.Result))
                this.addmbsp(this.dqcfobj)
              }
            })
      }
    }
  },
  created() {
    getCp('operation,drug,exam,treatment,labtest')
    .then(res => {
      if (res.GetRelationListResult) {
        // console.log(res.GetRelationListResult)
        let obj = res.GetRelationListResult,
            py = [],
            jc = [],
            mz = [],
            ss = [],
            hy = []
        for (let i = 0; i < obj.length; i++) {
          if (obj[i].ProductDetail.AllProduct.ProductSortKey == 'drug') {
            py.push({
              value: obj[i].ProductDetail.AllProduct.ProductId,
              label: obj[i].ProductDetail.AllProduct.ProductName
            })
            this.ypwzarr.push(obj[i])
          }
          if (obj[i].ProductDetail.AllProduct.ProductSortKey == 'operation') {
            ss.push({
              value: obj[i].ProductDetail.AllProduct.ProductId,
              label: obj[i].ProductDetail.AllProduct.ProductName
            })
            this.sswzarr.push(obj[i])
          }
          if (obj[i].ProductDetail.AllProduct.ProductSortKey == 'treatment') {
            mz.push({
              value: obj[i].ProductDetail.AllProduct.ProductId,
              label: obj[i].ProductDetail.AllProduct.ProductName
            })
            this.mzwzarr.push(obj[i])
          }
          if (obj[i].ProductDetail.AllProduct.ProductSortKey == 'exam') {
            jc.push({
              value: obj[i].ProductDetail.AllProduct.ProductId,
              label: obj[i].ProductDetail.AllProduct.ProductName
            })
            this.jcwzarr.push(obj[i])
          }
          if (obj[i].ProductDetail.AllProduct.ProductSortKey == 'labtest') {
            hy.push({
              value: obj[i].ProductDetail.AllProduct.ProductId,
              label: obj[i].ProductDetail.AllProduct.ProductName
            })
            this.hywzarr.push(obj[i])
          }
        }
        this.yparr = [...py]
        this.jcarr = [...jc]
        this.mzarr = [...mz]
        this.ssarr = [...ss]
        this.hyarr = [...hy]
      }
    })

    //res.GetRelationListResult[i].ShopProduct.SPAmount

    this.GETgwcss()

    this.getcflb()
  },

  methods: {
    getcflb() {
      getcflist()
          .then(res => {
            if (res.Result && res.Result.length) {
              let arr = []
              for (let i = 0; i < res.Result.length; i++) {
                arr.push({
                  value: res.Result[i].PTId,
                  label: res.Result[i].PTName
                })
              }
              this.cfopin = [...arr]
            }
          })
    },

    GETgwcss() {
      let logs = this.$loading({text: '加载中...'})
      getGWC()
          .then(res => {
            logs.close()
            this.gwcyp = [getcsz('drug')]
            this.gwcmz = [getcsz('treatment')]
            this.gwcss =  [getcsz('operation')]
            this.gwcjc =  [getcsz('exam')]
            this.gwchy = [getcsz('labtest')]
            let hys = []
            if (res.GetListResult) {
              for (let i = 0; i < res.GetListResult.length; i++) {
                if (res.GetListResult[i].CHPProductSortGroup == 'drug') {
                  if (res.GetListResult[i].CHPPrescriptionData) {res.GetListResult[i].CHPPrescriptionData = pf.decoding(res.GetListResult[i].CHPPrescriptionData)}
                  if (!this.gwcyp[0].CHPProductId) {
                    this.gwcyp = [res.GetListResult[i]]
                  }else {
                    this.gwcyp.push(res.GetListResult[i])
                  }
                }
                if (res.GetListResult[i].CHPProductSortGroup == 'exam') {
                  if (!this.gwcjc[0].CHPProductId) {
                    this.gwcjc = [res.GetListResult[i]]
                  }else {
                    this.gwcjc.push(res.GetListResult[i])
                  }
                }
                if (res.GetListResult[i].CHPProductSortGroup == 'treatment') {
                  if (!this.gwcmz[0].CHPProductId) {
                    this.gwcmz = [res.GetListResult[i]]
                  }else {
                    this.gwcmz.push(res.GetListResult[i])
                  }

                }
                if (res.GetListResult[i].CHPProductSortGroup == 'operation') {
                  if (!this.gwcss[0].CHPProductId) {
                    this.gwcss = [res.GetListResult[i]]
                  }else {
                    this.gwcss.push(res.GetListResult[i])
                  }
                }
                if (res.GetListResult[i].CHPProductSortGroup == 'labtest') {
                  // if (!this.gwchy[0].CHPProductId) {
                  //   this.gwchy = [res.GetListResult[i]]
                  // }else {
                  //   this.gwchy.push(res.GetListResult[i])
                  // }
                  hys.push(res.GetListResult[i])
                }
                if (res.GetListResult[i].CHPStatus == 1) {
                  res.GetListResult[i].zt = '待缴费'
                }
                if (res.GetListResult[i].CHPStatus == 2) {
                  res.GetListResult[i].zt = '已开单'
                }
              }
              // console.log(hys, 22222222)
              if (hys.length) {
                this.gwchy = [...hys]
              }
            }
          })
    },
    desqd() {
      this.gwcyp[this.ypxqIdx].CHPPrescriptionData = JSON.parse(JSON.stringify(this.ypitem))
      this.yyxqshow = false
    },

    openypxq(idx) {
      if (this.gwcyp[idx].CHPPrescriptionData) {
        this.ypitem = JSON.parse(JSON.stringify(this.gwcyp[idx].CHPPrescriptionData))
        if (this.gwcyp[idx].CHPStatus == 2) this.dqypzt = true
      }else {
        this.ypitem =  {
          Drug_Days: '',
          Drug_UseMethod: '',
          Drug_CountPerDay: '',
          Drug_TimeInDay: '',
          LeftOrRight: '',
          Drug_CountPerTime: '',
        }
        this.dqypzt = false
      }
      this.ypxqIdx = idx
      this.yyxqshow = true
    },

    xgnum(e, id) {
      // numbh(e, id)
      // .then(res => {
      //     if (res.msg !== 'Success') {
      //       this.$alert('增加数量失败！', '提示')
      //     }
      //   })
    },

    addsp(str) {
      let obj = {
            ChooseProductId: '',
            CHPProductSortGroup: str,
            CHPChooseId: this.$store.state.physicianVisits.xzConsulting,
            CHPPrescriptionData: '',
            CHPS_OP_ALL_Id: '00000000-0000-0000-0000-000000000000',
            CHPAmount: 1,
            CHPProductId: '',
            CHPPrice: '',
            CHPRequirements: '',
            CHPProductSource: '',
            CHPExpertId: this.$store.state.users.employees.ExpertId,
            CHPRemark: '',
            CHPStatus: 1,
            ProductRelation: {
              ProductDetail: {
                AllProduct: {}
              },
              ShopProduct: {
                SPAmount: '',
                SPbNoCountSale: false
              }
            }
          }
      if (str == 'drug') {
        this.gwcyp.push(obj)
      }

      if (str == 'exam') {
        this.gwcjc.push(obj)
      }

      if (str == 'treatment') {
        this.gwcmz.push(obj)
      }

      if (str == 'operation') {
        this.gwcss.push(obj)
      }

      if (str == 'labtest') {
        this.gwchy.push(obj)
      }
    },

    xzcp(e, idx, type) {

      if (type == 'drug') {
        let item = ''
        for (let i = 0; i < this.ypwzarr.length; i++) {
          if (this.ypwzarr[i].ProductDetail.AllProduct.ProductId == e) {
            item = JSON.parse(JSON.stringify(this.ypwzarr[i]))
            break
          }
        }

        if (item.ShopProduct.SPAmount < 1 && !item.ShopProduct.SPbNoCountSale) {
          this.gwcyp[idx].CHPProductId = ''
          this.gwcyp[idx].ProductRelation = {
            ProductDetail: {
              AllProduct: {}
            },
            ShopProduct: {
              SPAmount: '',
              SPbNoCountSale: false
            }
          }
          this.$alert('该产品无库存，无法添加')
        }else {
          this.gwcyp[idx].ProductRelation = item
        }
      }

      if (type == 'exam') {
        let item = ''
        for (let i = 0; i < this.jcwzarr.length; i++) {
          if (this.jcwzarr[i].ProductDetail.AllProduct.ProductId == e) {
            item = JSON.parse(JSON.stringify(this.jcwzarr[i]))
            break
          }
        }
        // this.gwcjc[idx].ProductRelation = item

        if (item.ShopProduct.SPAmount < 1 && !item.ShopProduct.SPbNoCountSale) {
          this.gwcjc[idx].CHPProductId = ''
          this.gwcjc[idx].ProductRelation = {
            ProductDetail: {
              AllProduct: {}
            },
            ShopProduct: {
              SPAmount: '',
              SPbNoCountSale: false
            }
          }
          this.$alert('该产品无库存，无法添加')
        }else {
          this.gwcjc[idx].ProductRelation = item
        }

      }

      if (type == 'treatment') {
        let item = ''
        for (let i = 0; i < this.mzwzarr.length; i++) {
          if (this.mzwzarr[i].ProductDetail.AllProduct.ProductId == e) {
            item = JSON.parse(JSON.stringify(this.mzwzarr[i]))
            break
          }
        }
        // this.gwcmz[idx].ProductRelation = item
        if (item.ShopProduct.SPAmount < 1 && !item.ShopProduct.SPbNoCountSale) {
          this.gwcmz[idx].CHPProductId = ''
          this.gwcmz[idx].ProductRelation = {
            ProductDetail: {
              AllProduct: {}
            },
            ShopProduct: {
              SPAmount: '',
              SPbNoCountSale: false
            }
          }
          this.$alert('该产品无库存，无法添加')
        }else {
          this.gwcmz[idx].ProductRelation = item
        }
      }

      if (type == 'operation') {
        let item = ''
        for (let i = 0; i < this.sswzarr.length; i++) {
          if (this.sswzarr[i].ProductDetail.AllProduct.ProductId == e) {
            item = JSON.parse(JSON.stringify(this.sswzarr[i]))
            break
          }
        }
        // this.gwcss[idx].ProductRelation = item
        if (item.ShopProduct.SPAmount < 1 && !item.ShopProduct.SPbNoCountSale) {
          this.gwcss[idx].CHPProductId = ''
          this.gwcss[idx].ProductRelation = {
            ProductDetail: {
              AllProduct: {}
            },
            ShopProduct: {
              SPAmount: '',
              SPbNoCountSale: false
            }
          }
          this.$alert('该产品无库存，无法添加')
        }else {
          this.gwcss[idx].ProductRelation = item
        }
      }

      if (type == 'labtest') {
        let item = ''
        for (let i = 0; i < this.hywzarr.length; i++) {
          if (this.hywzarr[i].ProductDetail.AllProduct.ProductId == e) {
            item = JSON.parse(JSON.stringify(this.hywzarr[i]))
            break
          }
        }
        // this.gwchy[idx].ProductRelation = item
        if (item.ShopProduct.SPAmount < 1 && !item.ShopProduct.SPbNoCountSale) {
          this.gwchy[idx].CHPProductId = ''
          this.gwchy[idx].ProductRelation = {
            ProductDetail: {
              AllProduct: {}
            },
            ShopProduct: {
              SPAmount: '',
              SPbNoCountSale: false
            }
          }
          this.$alert('该产品无库存，无法添加')
        }else {
          this.gwchy[idx].ProductRelation = item
        }
      }
    },

    save() {
      let itemobj = {
        ChooseProductId: '',
        CHPProductSortGroup: '',
        CHPChooseId: this.$store.state.physicianVisits.xzConsulting,
        CHPPrescriptionData: '',
        CHPS_OP_ALL_Id: '00000000-0000-0000-0000-000000000000',
        CHPAmount: 1,
        CHPProductId: '',
        CHPPrice: '',
        CHPRequirements: '',
        CHPProductSource: '',
        CHPExpertId: this.$store.state.users.employees.ExpertId,
        CHPRemark: '',
        CHPStatus: 1
      }

      let yparrs = []
      for (let i = 0; i < this.gwcyp.length; i++) {
        if (this.gwcyp[i].CHPProductId) {
          yparrs.push(JSON.parse(JSON.stringify(itemobj)))
          for (let key in yparrs[i]) {
            yparrs[i][key] = this.gwcyp[i][key]
          }
          yparrs[i].CHPPrice = this.gwcyp[i].ProductRelation.ProductDetail.AllProduct.ProductOfficalPrice
          yparrs[i].ChooseProductId = yparrs[i].ChooseProductId ? yparrs[i].ChooseProductId : '00000000-0000-0000-0000-000000000000'
          if (!yparrs[i].CHPStatus) yparrs[i].CHPStatus = 1
          if (yparrs[i].CHPPrescriptionData) {yparrs[i].CHPPrescriptionData = pf.conversionJson(yparrs[i].CHPPrescriptionData)}
        }
      }

      let jcarrs = []
      for (let i = 0; i < this.gwcjc.length; i++) {
        if (this.gwcjc[i].CHPProductId) {
          jcarrs.push(JSON.parse(JSON.stringify(itemobj)))
          for (let key in jcarrs[i]) {
            jcarrs[i][key] = this.gwcjc[i][key]
          }
          jcarrs[i].CHPPrice = this.gwcjc[i].ProductRelation.ProductDetail.AllProduct.ProductOfficalPrice
          jcarrs[i].ChooseProductId = jcarrs[i].ChooseProductId ? jcarrs[i].ChooseProductId : '00000000-0000-0000-0000-000000000000'
          if (!jcarrs[i].CHPStatus) jcarrs[i].CHPStatus = 1
        }
      }


      let mzarrs = []
      for (let i = 0; i < this.gwcmz.length; i++) {
        if (this.gwcmz[i].CHPProductId) {
          mzarrs.push(JSON.parse(JSON.stringify(itemobj)))
          for (let key in mzarrs[i]) {
            mzarrs[i][key] = this.gwcmz[i][key]
          }
          mzarrs[i].CHPPrice = this.gwcmz[i].ProductRelation.ProductDetail.AllProduct.ProductOfficalPrice
          mzarrs[i].ChooseProductId =  mzarrs[i].ChooseProductId ? mzarrs[i].ChooseProductId : '00000000-0000-0000-0000-000000000000'
          if (!mzarrs[i].CHPStatus) mzarrs[i].CHPStatus = 1
        }
      }

      let ssarrs = []
      for (let i = 0; i < this.gwcss.length; i++) {
        if (this.gwcss[i].CHPProductId) {
          ssarrs.push(JSON.parse(JSON.stringify(itemobj)))
          for (let key in ssarrs[i]) {
            ssarrs[i][key] = this.gwcss[i][key]
          }
          ssarrs[i].CHPPrice = this.gwcss[i].ProductRelation.ProductDetail.AllProduct.ProductOfficalPrice
          ssarrs[i].ChooseProductId =  ssarrs[i].ChooseProductId ? ssarrs[i].ChooseProductId : '00000000-0000-0000-0000-000000000000'
          if (!ssarrs[i].CHPStatus) ssarrs[i].CHPStatus = 1
        }
      }

      let hyarrs = []
      for (let i = 0; i < this.gwchy.length; i++) {
        if (this.gwchy[i].CHPProductId) {
          hyarrs.push(JSON.parse(JSON.stringify(itemobj)))
          for (let key in hyarrs[i]) {
            hyarrs[i][key] = this.gwchy[i][key]
          }
          hyarrs[i].CHPPrice = this.gwchy[i].ProductRelation.ProductDetail.AllProduct.ProductOfficalPrice
          hyarrs[i].ChooseProductId =  hyarrs[i].ChooseProductId ? hyarrs[i].ChooseProductId : '00000000-0000-0000-0000-000000000000'
          if (!hyarrs[i].CHPStatus) hyarrs[i].CHPStatus = 1
        }
      }

      let arr = [...yparrs,...jcarrs,...mzarrs,...ssarrs, ...hyarrs]

      this._http.post(this._getUrl('updateChooseList'), {
        "token":{
          "sToken":"7BA5E18877AE752DF55FC8874D0BF364",
          "TimeSpan":"1688356076"
        },
        lo: arr
      })
          .then(res => {
            // console.log(res)
            this.GETgwcss()
          })
    },

    delearr(idx, type) {
      if (type == 'drug') {
        if (this.gwcyp.length === 1) {
          this.gwcyp = [getcsz('drug')]
        }else {
          this.gwcyp.splice(idx, 1)
        }
      }

      if (type == 'exam') {
        if (  this.gwcjc .length === 1) {
          this.gwcjc = [getcsz('exam')]
        }else {
          this.gwcjc.splice(idx, 1)
        }
      }


      if (type == 'treatment') {
        if (this.gwcmz .length === 1) {
          this.gwcmz = [getcsz('treatment')]
        }else {
          this.gwcmz.splice(idx, 1)
        }
      }

      if (type == 'operation') {
        if (this.gwcss.length === 1) {
          this.gwcss = [getcsz('operation')]
        }else {
          this.gwcss.splice(idx, 1)
        }
      }

      if (type == 'labtest') {
        if (this.gwchy.length === 1) {
          this.gwchy = [getcsz('labtest')]
        }else {
          this.gwchy.splice(idx, 1)
        }
      }
    },

    deles(id, idx, type) {
      // console.log(id, idx, type)
      if (id === '00000000-0000-0000-0000-000000000000' || !id) {
        this.delearr(idx, type)
        // console.log(289189127172)
        return
      }
      if (type == 'drug' && this.gwcyp[idx].CHPStatus == 2) return;
      if (type == 'exam' && this.gwcjc[idx].CHPStatus == 2) return;
      if (type == 'treatment' && this.gwcmz[idx].CHPStatus == 2) return;
      if (type == 'operation' && this.gwcss[idx].CHPStatus == 2) return;
      if (type == 'labtest' && this.gwchy[idx].CHPStatus == 2) return;

      this._http.post(this._getUrl('deleteProductFromList'), {
        "token" : {    "sToken" : "B2671FDA9B7F5526FD0E64E8561BFC69",    "TimeSpan" : "1688355668"  },  "ChooseProductId" : id
      })
          .then(res => {
            if (res.DeleteByIdResult) {
              this.delearr(idx, type)
              // this.GETgwcss()
            }else {
              this.$alert('删除失败', '提示')
            }
          })
    },

    sqdFn(e, lx, zt, id) {
      if (!id) {
        return this.$alert('请先保存才能开单')
      }
      this.ifcs = e
      this.dqcfxx = {
        lx: lx,
        zt: zt
      }
      this.showif = true
    },

    showaddmbss() {
      if (this.osds && this.odds) {
        if (this.osds != this.odds) {
          return this.$alert('双眼病症应该一致', '提示')
        }
      }
      if (this.odds === '' && this.osds === '') {
        return this.$alert('新增模板前请选一种病症', '提示')
      }
      this.showaddmb = true
    },
    addmb(){
      if (this.mbName == '') {
        return this.$alert('请输入模板名称', '提示')
      }
      let obj = {
        n: this.mbName,
        s: this.mbsm,
        b: this.odds || this.osds
      }
      let arr = [...mbxx(this.gwcyp), ...mbxx(this.gwcjc), ...mbxx(this.gwchy), ...mbxx(this.gwcmz), ...mbxx(this.gwcss)]
      let log = this.$loading({text: '增加中...'})
      addnmb(obj, arr)
      .then(res => {
        log.close()
        this.$alert(res.displaymsg, '提示')
        .then(r => {
          this.getcflb()
          this.showaddmb = false
        })
        // console.log(res)
      })
    },

    addmbsp(objsss) {
      for (let i = 0; i < objsss.PTDetails.length; i++) {

        let  item = objsss.PTDetails[i]


        let str = item.ProductSortKey
        let obj = {
          ChooseProductId: '',
          CHPProductSortGroup: item.ProductSortKey,
          CHPChooseId: this.$store.state.physicianVisits.xzConsulting,
          CHPPrescriptionData: item.PTDPrescriptionData ? pf.decoding2(item.PTDPrescriptionData) : '',
          CHPS_OP_ALL_Id: '00000000-0000-0000-0000-000000000000',
          CHPAmount: item.PTDCount,
          CHPProductId: item.PTDProductId,
          CHPPrice: item.ProductPrice,
          CHPRequirements: '',
          CHPProductSource: '',
          CHPExpertId: this.$store.state.users.employees.ExpertId,
          CHPRemark: item.PTDRemark,
          CHPStatus: 1,
          ProductRelation: {
            ProductDetail: {
              AllProduct: {
                ProductPrice: item.ProductPrice,
                CHPProductId: item.PTDProductId
              }
            },
            ShopProduct: {}
          }
        }


        if (str == 'drug') {
          let ps = {
            SPAmount: '',
            SPbNoCountSale: false
          }

          for (let j = 0; j < this.ypwzarr.length; j++) {
            if (this.ypwzarr[j].ShopProduct.SPProductId == objsss.PTDetails[i].PTDProductId) {
              ps = this.ypwzarr[j].ShopProduct
              break
            }
          }
          obj.ShopProduct = JSON.parse(JSON.stringify(ps))

          if (this.gwcyp[0].CHPProductId) {
            this.gwcyp.push(obj)
          }else {
            this.gwcyp[0] = JSON.parse(JSON.stringify(obj))
          }
        }

        if (str == 'exam') {
          let ps = {
            SPAmount: '',
            SPbNoCountSale: false
          }
          for (let j = 0; j < this.jcwzarr.length; j++) {
            if (this.jcwzarr[j].ShopProduct.SPProductId == objsss.PTDetails[i].PTDProductId) {
              ps = this.jcwzarr[j].ShopProduct
              break
            }
          }
          obj.ShopProduct = JSON.parse(JSON.stringify(ps))

          if (this.gwcjc[0].CHPProductId) {
            this.gwcjc.push(obj)
          }else {
            this.gwcjc[0] = JSON.parse(JSON.stringify(obj))
          }
        }

        if (str == 'treatment') {
          let ps = {
            SPAmount: '',
            SPbNoCountSale: false
          }
          for (let j = 0; j < this.mzwzarr.length; j++) {
            if (this.mzwzarr[j].ShopProduct.SPProductId == objsss.PTDetails[i].PTDProductId) {
              ps = this.mzwzarr[j].ShopProduct
              break
            }
          }
          obj.ShopProduct = JSON.parse(JSON.stringify(ps))


          if (this.gwcmz[0].CHPProductId) {
            this.gwcmz.push(obj)
          }else {
            this.gwcmz[0] = JSON.parse(JSON.stringify(obj))
          }
        }

        if (str == 'operation') {
          let ps = {
            SPAmount: '',
            SPbNoCountSale: false
          }
          for (let j = 0; j < this.sswzarr.length; j++) {
            if (this.sswzarr[j].ShopProduct.SPProductId == objsss.PTDetails[i].PTDProductId) {
              ps = this.sswzarr[j].ShopProduct
              break
            }
          }
          obj.ShopProduct = JSON.parse(JSON.stringify(ps))


          if (this.gwcss[0].CHPProductId) {
            this.gwcss.push(obj)
          }else {
            this.gwcss[0] = JSON.parse(JSON.stringify(obj))
          }
        }


        if (str == 'labtest') {
          let ps = {
            SPAmount: '',
            SPbNoCountSale: false
          }
          for (let j = 0; j < this.hywzarr.length; j++) {
            if (this.hywzarr[j].ShopProduct.SPProductId == objsss.PTDetails[i].PTDProductId) {
              ps = this.hywzarr[j].ShopProduct
              break
            }
          }
          obj.ShopProduct = JSON.parse(JSON.stringify(ps))


          if (this.gwchy[0].CHPProductId) {
            this.gwchy.push(obj)
          }else {
            this.gwchy[0] = JSON.parse(JSON.stringify(obj))
          }
        }
      }

    },

    upmb() {
      // console.log(this.dqcfobj)
      if (this.dqcfobj.PTId) {
        if (this.dqcfobj.PTRange == 'expert') {
          if (this.osds && this.odds) {
            if (this.osds != this.odds) {
              return this.$alert('双眼病症应该一致', '提示')
            }
          }
          if (!this.dqcfobj.PTName) return this.$alert('请输入模板名称', '提示')
          let arr = [...mbxx(this.gwcyp), ...mbxx(this.gwcjc), ...mbxx(this.gwchy), ...mbxx(this.gwcmz), ...mbxx(this.gwcss)],
              bz = this.odds || this.osds
          this.dqcfobj.PTDetails = [...arr]
          this.dqcfobj.PTDisease = bz || this.dqcfobj.PTDisease
          let log = this.$loading({text: '修改中...'})
          upmbfn(this.dqcfobj)
          .then(res => {
            log.close()
            this.$alert(res.displaymsg, '提示')
            .then(r => {
              this.showupmb = false
            })
          })
        }else {
          this.$alert('共用处方模板不允许删除或修改', '提示')
        }
      }else {
        this.$alert('请选择修改的模板', '提示')
      }
    },

    delmbfn() {
      this.$confirm('请确认是否删除该模板，删除后不可以恢复？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let log = this.$loading({text: '删除中...'})
        delemb(this.dqcfobj.PTId)
        .then(r => {
          log.close()
          if (r.ReturnCode == 5000) {
            for (let i = 0; i < this.cfopin.length; i++) {
              if ( this.cfopin[i].value == this.dqcfobj.PTId) {
                this.cfopin.splice(i, 1)
                this.dqcfobj = {}
                this.cfval = ''
                break
              }
            }
            // console.log(this.cfopin)
          }
        })
      }).catch(() => {
      });
    }
  },
  components: {
    IFTC: () => import('./IFTC')
  }
}
</script>

<style scoped lang="scss">
.exCl {
  width: calc(100% - 30px);
  margin-bottom: 20px;
  position: relative;
}
.bt-m {
  display: flex;
  justify-content: space-between;
  border: 1px solid #a7a7a7;
  li {
    width: calc(50% - 330px);
    border-right: 1px solid #a7a7a7;
    padding: 5px 0;
    cursor: pointer;
  }
  li:nth-child(1) {width: 100px;}
  li:nth-child(3) {width: 80px;}
  li:nth-child(4) {width: 80px}
  li:nth-child(5) {width: 80px}
  li:nth-child(6) {width: 80px}
  li:nth-child(7) {width: 80px}
  li:nth-child(8) {width: 80px;}
  li:nth-child(10) {width: 80px;border-right: none;}
}
.nrboxo {
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    p {margin-right: 5px;width: 4em;}
    .yf {
      border: none;
      outline: none;
      width: 100%;
      text-align: center;
    }
  }
}
.ykd {
  background: #47ff77;
}
.yyxq {
  display: flex !important;
  //flex-wrap: ;
  justify-content: center;
  li {
    padding-left: 15px;
    padding-bottom: 10px;
    p {
      padding-bottom: 5px;
    }
  }
}
.mbbox {
  display: flex;
  justify-content: right;
  position: absolute;
  top: -40px;
  right: 0;
}
</style>
